"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _PropTypes = _interopRequireDefault(require("react-utils/PropTypes"));

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _UISubheader = _interopRequireDefault(require("UIComponents/layout/UISubheader"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _AsyncAdvancedMenus = _interopRequireDefault(require("./AsyncAdvancedMenus"));

var NavigationSettingsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(NavigationSettingsContainer, _PureComponent);

  function NavigationSettingsContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, NavigationSettingsContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NavigationSettingsContainer).call(this, props));
    _this.onMenuChange = _this.onMenuChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(NavigationSettingsContainer, [{
    key: "onMenuChange",
    value: function onMenuChange(id) {
      var pushRoute = this.props.push;
      pushRoute(_UrlPathParams.WEBSITE + "/" + _UrlPathParams.NAVIGATION + "/" + id);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement(_UISubheader.default, {
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "website.navigation.header"
        })
      }, _react.default.createElement("p", {
        className: "m-top-3"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "website.navigation.intro"
      }))), _react.default.createElement(_AsyncAdvancedMenus.default, {
        auth: this.props.auth,
        onMenuChange: this.onMenuChange,
        selectedMenuId: this.props.menuId
      }));
    }
  }]);
  return NavigationSettingsContainer;
}(_react.PureComponent);

NavigationSettingsContainer.propTypes = {
  auth: _PropTypes.default.object.isRequired,
  menuId: _PropTypes.default.number,
  push: _PropTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    auth: (0, _selectors.getAuth)(state),
    menuId: parseInt(props.params.menuId, 10)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  push: _reactRouterRedux.push
})(NavigationSettingsContainer);

exports.default = _default;
module.exports = exports.default;